/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _clamp = _interopRequireDefault(require("../../../../common/clamp"));
function getNewActiveTagOnRemove(_ref) {
  var id = _ref.id,
    value = _ref.value,
    dir = _ref.dir;
  dir = dir || -1;
  if (!Array.isArray(value) || value.length === 1) {
    return null;
  }
  var newActiveTag = null;
  var currentIndex = value.indexOf(id);
  var lastIndex = value.length - 1;
  var newIndex = (0, _clamp.default)(currentIndex + dir, 0, lastIndex);
  if (dir == 1 && currentIndex === lastIndex) {
    newIndex = (0, _clamp.default)(currentIndex - 1, 0, lastIndex);
  }
  if (dir == -1 && currentIndex == 0 && lastIndex > 0) {
    newIndex = 1;
  }
  newActiveTag = value[newIndex];
  return newActiveTag;
}
var _default = getNewActiveTagOnRemove;
exports.default = _default;